import React from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../component/Header' 
import SubBanner from '../component/SubBanner' 
import ProductList from '../component/ProductList' 
// import MedicineHealthProducts from '../component/MedicineHealthProducts' 
// import OfferSection from '../component/OfferSection' 
// import PowerNature from '../component/PowerNature' 
// import Testimonials from '../component/Testimonials' 
// import OurBlogArticle from '../component/OurBlogArticle' 
import ATC from '../component/ATC' 
import { Helmet } from 'react-helmet-async';
import MobileProductHeader from '../component/MobileProductHeader'

function Products() {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const formatSlugTitle = (slug) =>
    slug
      .split('-')
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

  const getParamTitle = (key) => {
    const value = searchParams.get(key)
    if (!value) return null

    return value
      .split(',')
      .filter(Boolean)
      .map(formatSlugTitle)
      .join(', ')
  }

  const titleGroups = [
    { label: 'Categories', keys: ['categories'] },
    { label: 'Medicine Forms', keys: ['medicineForms', 'medicineforms'] },
    { label: 'Age Groups', keys: ['ageGroups', 'agegroups'] },
    { label: 'Health Interests', keys: ['healthInterests', 'healthinterests'] },
    { label: 'Dietary Needs', keys: ['dietaryNeeds'] },
    { label: 'Brands', keys: ['brands'] },
  ]

  const getFirstAvailableParamTitle = (keys) => {
    for (const key of keys) {
      const value = getParamTitle(key)
      if (value) return value
    }
    return null
  }

  const activeGroups = titleGroups
    .map(({ label, keys }) => {
      const values = getFirstAvailableParamTitle(keys)
      return values ? { label, values } : null
    })
    .filter(Boolean)

  const dynamicTitle = activeGroups.length
    ? activeGroups.map(({ values }) => values).join(', ')
    : 'Our Products'

  const pageTitle = activeGroups.length
    ? `Products | ${activeGroups.map(({ label, values }) => `${label} - ${values}`).join(' | ')}`
    : 'Products | HealthGonia'

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Browse through our wide range of healthcare products at HealthGonia. Find the right products for your health and well-being." />
        <meta name="keywords" content="Healthcare Products, HealthGonia, Medical Supplies, Wellness Products, Health Products" />
      </Helmet>

      <div className='main'>
        <Header mobileTitle={dynamicTitle}/>
         <MobileProductHeader title={dynamicTitle} />
        <SubBanner HeaderTitle={dynamicTitle} HeaderSubtitle=""/>        
        <ProductList />        
        {/* 
        <MedicineHealthProducts />
        <OfferSection />
        <PowerNature />
        <Testimonials />
        <OurBlogArticle blogTitle="Our Blog & Article" /> */}
        <ATC />
      </div>
    </>
  )
}
export default Products


